var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstituteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3708_27247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9689 3.80518L10.1515 0.710999C10.0301 0.670552 9.90881 0.670552 9.80769 0.710999L0.990282 3.80518C0.788048 3.88607 0.646484 4.06809 0.646484 4.29054V6.49479C0.646484 6.77792 0.889165 7.0206 1.17229 7.0206H18.8476C19.1307 7.0206 19.3734 6.77792 19.3734 6.49479V4.29054C19.3329 4.06809 19.1914 3.88607 18.9689 3.80518Z",
    fill: "#C4D8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8073 16.3235H17.0276V8.90121C17.0276 8.7192 16.8861 8.57764 16.7041 8.57764H14.075C13.893 8.57764 13.7515 8.7192 13.7515 8.90121V16.3235H11.6078V8.90121C11.6078 8.7192 11.4662 8.57764 11.2842 8.57764H8.65516C8.47315 8.57764 8.33158 8.7192 8.33158 8.90121V16.3235H6.20813V8.90121C6.20813 8.7192 6.06656 8.57764 5.88455 8.57764H3.25551C3.0735 8.57764 2.93193 8.7192 2.93193 8.90121V16.3235H1.15227C0.869146 16.3235 0.626465 16.5662 0.626465 16.8493V19.1547C0.626465 19.4378 0.869146 19.6805 1.15227 19.6805H18.8275C19.1107 19.6805 19.3533 19.4378 19.3533 19.1547V16.8493C19.3331 16.5662 19.0904 16.3235 18.8073 16.3235Z",
    fill: "#C4D8FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3708_27247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.180664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstituteIcon);
export default __webpack_public_path__ + "static/media/instituteIcon.f048911463a6dbadcd89be1f459f7b60.svg";
export { ForwardRef as ReactComponent };